"use client";

import OptionSelect from "@/components/select/option-select";
import { adTypeOption } from "@/constants/adType";

interface AdTypeSelectProps {
  name?: string;
  label?: string;
  placeholder?: string;
  wrapperClassName?: string;
  value?: string | null;
  onChange?: (value: string | null) => void;
  onBlur?: () => void;
  showClearButton?: boolean;
  className?: string;
}

export default function AdTypeSelect({
  label = "نوع آگهی",
  placeholder = "نوع آگهی را انتخاب کنید",
  wrapperClassName,
  value,
  onChange,
  showClearButton = true,
  className,
}: Readonly<AdTypeSelectProps>) {
  return (
    <OptionSelect
      options={adTypeOption}
      label={label}
      placeholder={placeholder}
      wrapperClassName={wrapperClassName}
      value={value}
      onChange={onChange}
      showClearButton={showClearButton}
      className={className}
    />
  );
}
